import React, { FC } from 'react';
import { Descriptions as AntdDescriptions } from '@firesoon/antd';
import { DescriptionsProps } from '@firesoon/antd/lib/descriptions';
import classnames from 'classnames';
import Label from '../Text/label';
import Text from '../Text';
import Item from './Item';
import './index.less';

const Descriptions: FC<DescriptionsProps> = (props) => {
  const { className, layout = 'horizontal', children } = props;

  const newChildren = React.Children.toArray(children).map((item) => {
    const _item = item as React.ReactElement;
    const { label, children, contentStyle, span, ...rest } = _item.props || {};
    /** 如果不适用Item包一层 会报错 不然没办法做下面的包裹 */
    if (_item.type !== Item) {
      throw new Error('A component must contain Descriptions.Item component as a child');
    }

    const _label = (() => {
      if (label) {
        if (typeof label === 'string') {
          return <Label colon={false}>{label}</Label>;
        }
        return <Label {...label} colon={false} />;
      }
    })();

    return (
      <AntdDescriptions.Item key={_item.key} label={_label} span={span}>
        <Text {...rest}>{children}</Text>
      </AntdDescriptions.Item>
    );
  });

  return (
    <AntdDescriptions {...props} className={classnames('fs-descriptions', `fs-descriptions-${layout}`, className)}>
      {newChildren}
    </AntdDescriptions>
  );
};

export default Descriptions;
